export default "__VITE_ASSET__5d5ce303__"